export enum ESignupErrorCode {
	EMAIL_ALREADY_EXISTS = "EMAIL_ALREADY_EXISTS",
	EMAIL_NOT_VERIFIED = "EMAIL_NOT_VERIFIED",
	ACCOUNT_BLOCKED = "ACCOUNT_BLOCKED"
}